export function linkToProfile(address: string) {
  const link = process.env.REACT_APP_XANALIA_FRONT_END + '/profile/' + address
  return link
}

export function swithToProfile(address: string) {
  const { open } = window
  open(linkToProfile(address), '_blank')
}

export function linkToTwitter(username: string) {
  const link = 'https://twitter.com/' + username
  return link
}

export function swithToTwitter(username: string) {
  const { open } = window
  open(linkToProfile(username), '_blank')
}
